import { cn } from "@/utils/cn";
import { CheckedIcon, CheckIcon, CheckingIcon } from "./assets";
import { useTranslation } from "react-i18next";

interface StepItemProps {
  active: number;
  label: string;
  value: number;
}

const StepItem = ({ active, label, value }: StepItemProps) => {
  return (
    <div className={cn("flex items-center gap-1.5")}>
      <div className="relative flex items-center justify-center w-9 h-9">
        <CheckedIcon
          className={cn(
            "absolute w-8 h-8 rounded-full",
            active > value ? "opacity-100 scale-100" : "obacity-0 scale-0"
          )}
        />
        <CheckingIcon
          className={cn(
            "absolute rounded-full size-7",
            active === value ? "obacity-100 scale-100" : "opacity-0 scale-0"
          )}
        />
        <CheckIcon
          className={cn(
            "absolute w-6 h-6 rounded-full",
            active < value ? "obacity-100 scale-100" : "opacity-0 scale-0"
          )}
        />
      </div>
      <span
        className={cn(
          "text-sm",
          active
            ? "text-[rgba(117,66,247,1)] font-semibold"
            : "text-[rgba(52,64,84,1)] font-medium"
        )}
      >
        {label}
      </span>
    </div>
  );
};

interface LineProps {
  active: boolean;
}

const Line = ({ active }: LineProps) => {
  return (
    <div
      className={cn(
        "w-36 h-0.5 bg-[rgba(234,236,240,1)]",
      )}
    />
  );
};

interface StepIndicatorProps {
  className?: string;
  currentStep: 0 | 1 | 2 | 3;
}

export const StepIndicator = ({
  className,
  currentStep,
}: StepIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className={cn("flex items-center gap-3")}>
        {/* Upload Step */}
        <StepItem active={currentStep} label={t("custom_digital_human.upload_form.upload")} value={0} />

        <Line active={currentStep >= 1} />

        {/* Verify Step */}
        <StepItem active={currentStep} label={t("custom_digital_human.upload_form.Verify")} value={1} />

        <Line active={currentStep >= 2} />

        {/* Create Step */}
        <StepItem active={currentStep} label={t("custom_digital_human.upload_form.Create")} value={2} />
      </div>
    </div>
  );
};
